/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC, useEffect, useState } from 'react';

import { useAppNavigate } from '../utils/navigation';
import TableSearch from './components/DashboardTable/TableSearch';

interface IHashEditProps {
  placeholder?: string;
  className?: string;
  onSearch: (searchQuery: string) => void;
  disabled?: boolean;
}

const HashEditInput: FC<IHashEditProps> = ({
  placeholder,
  className,
  onSearch,
  disabled,
}) => {
  const { navigateTo } = useAppNavigate();
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    setValue(location.hash.replace('#', ''));
  }, []);

  function onTableSearch(value: string): void {
    navigateTo(`#${value}`, { replace: true });

    onSearch(value);
  }

  return (
    <TableSearch
      {...{ className, placeholder, value, disabled, onSearch: onTableSearch }}
    />
  );
};

export default HashEditInput;
